import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  noPaymentDefaults: {
    id: 'infoSearch.noPaymentDefaults',
    defaultMessage: 'Ei maksuhäiriöitä',
  },
  noData: {
    id: 'infoSearch.noData',
    defaultMessage: 'Ei tietoja',
  },
  fetchFailed: {
    id: 'infoSearch.fetchFailed',
    defaultMessage: 'Tietojen haku epäonnistui',
  },
  fetchedAtPrefix: {
    id: 'infoSearch.fetchedAtPrefix',
    defaultMessage: 'Haettu: ',
  },
  fetchedAtSuffix: {
    id: 'infoSearch.fetchedAtSuffix',
    defaultMessage: ' Bisnode Finland Oy:n rekisteristä',
  },
  saveButtonLabel: {
    id: 'infoSearch.saveButtonLabel',
    defaultMessage: 'Vie tilaukseen',
  },
  refresh: {
    id: 'infoSearch.refresh',
    defaultMessage: 'Päivitä',
  },
  personAndAddressInfo: {
    id: 'infoSearch.personAndAddressInfo',
    defaultMessage: 'Henkilö- ja Osoitetiedot',
  },
  firstName: {
    id: 'infoSearch.firstName',
    defaultMessage: 'Etunimi',
  },
  lastName: {
    id: 'infoSearch.lastName',
    defaultMessage: 'Sukunimi',
  },
  address: {
    id: 'infoSearch.address',
    defaultMessage: 'Osoite',
  },
  paymentDefaults: {
    id: 'infoSearch.paymentDefaults',
    defaultMessage: 'Maksuhäiriöt',
  },
  companyNameAndAddressInfo: {
    id: 'infoSearch.companyNameAndAddressInfo',
    defaultMessage: 'Yrityksen nimi ja osoitetiedot',
  },
  companyName: {
    id: 'infoSearch.companyName',
    defaultMessage: 'Yrityksen nimi',
  },
  companyRegistryInfo: {
    id: 'infoSearch.companyRegistryInfo',
    defaultMessage: 'Yrityksen rekisteritiedot',
  },
})
